import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const ShieldCheckIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 13 15" fill="none" {...props}>
    <path
      d="M4.08333 7.038L5.41667 8.37133L8.41667 5.37133M11.4167 7.37133C11.4167 10.6436 7.84736 13.0236 6.54866 13.7813C6.40107 13.8674 6.32727 13.9104 6.22312 13.9327C6.14229 13.9501 6.02437 13.9501 5.94355 13.9327C5.8394 13.9104 5.7656 13.8674 5.61801 13.7813C4.31931 13.0236 0.75 10.6436 0.75 7.37133V4.18307C0.75 3.65006 0.75 3.38356 0.837174 3.15447C0.914183 2.95209 1.03932 2.77152 1.20177 2.62835C1.38566 2.46629 1.6352 2.37272 2.13427 2.18557L5.7088 0.845116C5.8474 0.793142 5.9167 0.767155 5.98799 0.756853C6.05122 0.747716 6.11544 0.747716 6.17868 0.756853C6.24997 0.767155 6.31927 0.793142 6.45786 0.845116L10.0324 2.18557C10.5315 2.37272 10.781 2.46629 10.9649 2.62835C11.1273 2.77152 11.2525 2.95209 11.3295 3.15447C11.4167 3.38356 11.4167 3.65006 11.4167 4.18307V7.37133Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
